import React, { Component } from 'react';
import { connect } from "react-redux";
import TabSettings from 'components/__old/common/tabSettings.jsx';
import { customizeSVG } from 'utils/customizeSVG.jsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as InfoSquare } from "assets/images/icons/project-icons/info-square.svg";
import { toast } from 'react-toastify';
import * as info from "store/entities/settingsInfo/action";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";

class Integrations extends Component {

    state = {
        eraForm: {
            eraEmployer: false,
            eraEmployee: false,
            eraPayroll: false,
        }
    }


    updateCheckboxPayroll = (e) => {
        const formValue = {...this.state.eraForm};
        formValue[e.currentTarget.name] = e.currentTarget.checked;
        this.setState({eraForm: formValue});
        
        const { eraPayroll } = this.state.eraForm;
        const params = {
            toggle: !(eraPayroll),
        }

        if (this.props.eraPayrollLoading === false){
            this.props.togglePayroll(params).then(() => {
                toast.success("Payroll " + (eraPayroll ? "deactivated" : "activated") + " successfully");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
        }
    };


    updateCheckboxEraEmployees = (e) => {
        const formValue = {...this.state.eraForm};
        formValue[e.currentTarget.name] = e.currentTarget.checked;
        this.setState({eraForm: formValue});
        
        if (this.state.eraForm.eraEmployee === false){
            if (this.props.createBulkEmployeeEVALoading === false){
                toast("Activating employee ERA");
                this.props.createBulkEmployeeEVA().then(() => {
                    toast.success("Employee ERA activated successfully");
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                })
            }
        }
        else{
            this.props.toggleOffEmployeeEva().then(() => {
                toast.success("Employee ERA deactivated successfully");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            })
        }
        
        this.setState({eraForm: formValue});
    };


    componentDidMount() {
        this.props.getCompanyInfo().then(() => {
            
            const { companyInfo } = this.props;
            const eraForm = {
                ...this.state.eraForm,
                eraEmployer: companyInfo.companyEva,
                eraEmployee: companyInfo.employeeEva,
                eraPayroll: companyInfo.payroll,
            }
            this.setState({eraForm});

        }).catch(err => {
            
        })
    }
    

    render() { 
        customizeSVG();
        const { getCompanyInfoLoading, companyInfo, createBulkEmployeeEVALoading, eraPayrollLoading, employeeEraOffLoading } = this.props;
        const { eraForm } = this.state;
        // console.log("createBulkEmployeeEVALoading", createBulkEmployeeEVALoading);
        // console.log("createBulkEmployeeEVAContent", createBulkEmployeeEVAContent);
        // console.log("companyInfo", companyInfo);

        return ( 
            <div>

                <DynamicHeadTag
                    headerText="Settings"
                    headerDescription="Customize your account preferences, including account information, security and privacy settings, notifications, and other account-related options."
                />
                
                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Settings
                        </div>
                    </div>
                </div>

                <TabSettings />

                <div className="mt-8 space-y-6 lg:space-y-0">
                        
                    <div className="box max-w-4xl">
                        
                        
                        {(getCompanyInfoLoading === true) && 
                            <div className="table-info">
                                <FontAwesomeIcon icon="circle-notch" spin />
                                <div className="font-bold uppercase">
                                    Loading
                                </div>
                            </div>
                        }

                        {(getCompanyInfoLoading === false) && (!companyInfo) && 
                            <div className="table-info">
                                <FontAwesomeIcon icon="unlink" />
                                <div className="font-bold uppercase">
                                    An error occurred
                                    <br />
                                    Please try again later.
                                </div>
                            </div>
                        }

                        {(getCompanyInfoLoading === false) && (companyInfo) && 
                            <>



                                <div className="px-0 sm:px-5 py-6 sm:py-10 flex space-x-4 sm:space-x-10 border-b border-gray-200">
                                    <div className="flex-grow">
                                        <div className="font-semibold text-lg">
                                            Earnipay pays your employee's net salaries on your behalf
                                        </div>
                                        <div className="flex mt-4">
                                            <div className="hidden sm:block w-8 flex-shrink-0">
                                                <InfoSquare className="customizeSVG w-4 h-4 mt-0.5" />
                                            </div>
                                            <div style={{color: "#718096"}}>
                                                Given that your employees use Earnipay to withdraw their earned salaries within the month (before payday), we can help pay your employee's salaries on payday.
                                                <div>
                                                    <div className="font-bold mt-4">
                                                        How it works:
                                                    </div>
                                                    <div>
                                                        <ol className="ml-5 list-decimal">
                                                            <li>On/before payday, transfer the total monthly net salaries of your employees into the Earnipay bank account provided to you;</li>
                                                            <li>The total of what your employees have taken via Earnipay during the month will be deducted;</li>
                                                            <li>The outstanding balance is transferred to your employee's bank account.</li>
                                                            <li>That's it. It is a monthly recurring process.</li>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-20 lg:w-40 flex-shrink-0 lg:flex lg:space-x-3 space-y-1 lg:space-y-0">

                                        <div className="checkbox lg:-mt-1 flex-shrink-0">
                                            <label className="checkbox-switch cursor-pointer inline-block">
                                                <input type="checkbox" name="eraPayroll" className="checkbox" onChange={this.updateCheckboxPayroll} checked={eraForm.eraPayroll} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>

                                        <div className="font-medium">
                                            {(eraPayrollLoading === true) &&
                                                <div>
                                                    <FontAwesomeIcon icon="circle-notch" spin />
                                                    &nbsp;Loading
                                                </div>
                                            }
                                            {(eraPayrollLoading === false) &&
                                                <>
                                                    {(eraForm.eraPayroll) &&
                                                        <div>
                                                            Activated
                                                        </div>
                                                    }
                                                    {(!eraForm.eraPayroll) &&
                                                        <div>
                                                            Deactivated
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </div>

                                    </div>
                                </div>



                                <div className="px-0 sm:px-5 py-6 sm:py-10 flex space-x-4 sm:space-x-10 border-b border-gray-200">
                                    <div className="flex-grow">
                                        <div className="font-semibold text-lg">
                                            Earnipay Reconciliation Account (ERA) for all your Employees
                                        </div>
                                        <div className="flex mt-4">
                                            <div className="hidden sm:block w-8 flex-shrink-0">
                                                <InfoSquare className="customizeSVG w-4 h-4 mt-0.5" />
                                            </div>
                                            <div style={{color: "#718096"}}>
                                                Earnipay assigns each of your employees an ERA. The ERA is an account that automatically deducts your employee's Earnipay withdrawals from their net salaries.
                                                <div>
                                                    <div className="font-bold mt-4">
                                                        How it works:
                                                    </div>
                                                    <div>
                                                        <ol className="ml-5 list-decimal">
                                                            <li>Each of your employees is given an ERA; </li>
                                                            <li>On payday, you will pay your employees' salaries into their ERAs; </li>
                                                            <li>Whatever they have withdrawn during the month via Earnipay will be automatically deducted from their ERAs; </li>
                                                            <li>Their ERAs' net balance is instantly transferred into their bank accounts (Eg, Sterling, Firstbank).</li>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-20 lg:w-40 flex-shrink-0 lg:flex lg:space-x-3 space-y-1 lg:space-y-0">

                                        <div className="checkbox lg:-mt-1 flex-shrink-0">
                                            <label className="checkbox-switch cursor-pointer inline-block">
                                                <input type="checkbox" name="eraEmployee" className="checkbox" onChange={this.updateCheckboxEraEmployees} checked={eraForm.eraEmployee} />
                                                <span className="slider round"></span>
                                            </label>
                                        </div>

                                        <div className="font-medium">
                                            {(createBulkEmployeeEVALoading === true || employeeEraOffLoading === true) &&
                                                <div>
                                                    <FontAwesomeIcon icon="circle-notch" spin />
                                                    &nbsp;Loading
                                                </div>
                                            }
                                            {(createBulkEmployeeEVALoading === false && employeeEraOffLoading === false) &&
                                                <>
                                                    {(eraForm.eraEmployee) &&
                                                        <div>
                                                            Activated
                                                        </div>
                                                    }
                                                    {(!eraForm.eraEmployee) &&
                                                        <div>
                                                            Deactivated
                                                        </div>
                                                    }
                                                </>
                                            }
                                        </div>

                                    </div>
                                </div>



                            </>
                        }


                    </div>
                        
                </div>

            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    getCompanyInfoLoading: state.entities.settingsInfo.getLoading,
    companyInfo: state.entities.settingsInfo.companyInfo.company,
    createBulkEmployeeEVALoading: state.entities.settingsInfo.createBulkEmployeeEVALoading,
    createBulkEmployeeEVAContent: state.entities.settingsInfo.createBulkEmployeeEVAContent,

    eraPayrollLoading: state.entities.settingsInfo.eraPayrollLoading,
    eraPayroll: state.entities.settingsInfo.eraPayroll,
    employeeEraOffLoading: state.entities.settingsInfo.employeeEraOffLoading,
    employeeEraOff: state.entities.settingsInfo.employeeEraOff,
});

const mapDispatchToProps = (dispatch) => ({
    getCompanyInfo: () => dispatch(info.getInfo()),
    createBulkEmployeeEVA: () => dispatch(info.createBulkEmployeeEVA()),
    togglePayroll: (params) => dispatch(info.togglePayroll(params)),
    toggleOffEmployeeEva: () => dispatch(info.toggleOffEmployeeEva()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);